import {Controller} from "stimulus"
import {getDocument, GlobalWorkerOptions} from "pdfjs-dist/build/pdf"
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry"

export default class extends Controller {
  static targets = ["viewer", "input"]
  static values = {
    url: String
  }

  scale = 1.0
  pdf = null

  connect() {
    GlobalWorkerOptions.workerSrc = pdfjsWorker
    this.loadPdf()
  }

  async loadPdf() {
    const loadingTask = getDocument(this.urlValue)
    this.pdf = await loadingTask.promise
    this.renderPages()
  }

  async renderPages() {
    for (let pageNum = 1; pageNum <= this.pdf.numPages; pageNum++) {
      this.renderPage(pageNum);
    }
  }

  async renderPage(pageNum) {
    const viewerWidth = this.viewerTarget.clientWidth
    const devicePixelRatio = window.devicePixelRatio || 1
    const page = await this.pdf.getPage(pageNum)

    let viewport = page.getViewport({scale: this.scale})
    const viewportWidth = viewport.width
    const viewportHeight = viewport.height
    const scale = (viewerWidth / viewport.width) * devicePixelRatio
    viewport = page.getViewport({scale: scale})

    let wrapper = document.createElement("div");
    wrapper.style.position = "relative";
    let canvas = document.createElement("canvas")
    canvas.height = Math.floor(viewport.height * devicePixelRatio);
    canvas.width = Math.floor(viewport.width * devicePixelRatio);
    canvas.style.width = Math.floor(viewportWidth) + "px";
    canvas.style.height = Math.floor(viewportHeight) + "px";
    wrapper.appendChild(canvas);
    this.viewerTarget.appendChild(wrapper);

    const context = canvas.getContext("2d")
    const transform = devicePixelRatio !== 1 ? [devicePixelRatio, 0, 0, devicePixelRatio, 0, 0] : null;
    const renderContext = {
      canvasContext: context,
      transform: transform,
      viewport: viewport
    }
    await page.render(renderContext);
    this.renderFormFields(wrapper, page, viewportHeight);
    page.cleanup();
  }

  renderFormFields(wrapper, page, viewportHeight) {
    page.getAnnotations().then((annotations) => {
      this.inputTargets.forEach((input) => {
        let annotation = null;
        if (input.type === "radio") {
          annotation = annotations.find((annotation) => annotation.fieldName === input.dataset.name && annotation.buttonValue === input.value);
        } else {
          annotation = annotations.find((annotation) => annotation.fieldName === input.dataset.name);
        }
        if (annotation) {
          this.showInput(input, annotation, wrapper, viewportHeight);
        }
      });
    });
  }

  showInput(input, annotation, wrapper, viewportHeight) {
    const [x, y, width, height] = annotation.rect;
    input.style.left = `${x}px`;
    input.style.top = `${viewportHeight - height}px`;
    input.style.width = `${width - x}px`;
    input.style.height = `${height - y}px`;
    input.classList.remove("d-none");
    wrapper.appendChild(input);
  }
}
